import * as z from 'zod';
import { isArray, isObject, some, isString, keys } from 'lodash-es';
import debug from 'debug';
import { ComponentContext } from './schemas';

const log = debug('itp:runtime:scripting');

export const SCRIPT_SCHEMA = () =>
  z.string().regex(/^{{([\S\s]+)}}$/gm, 'Invalid script expression.');

export const hasNestedScriptExpression = (value: any): boolean => {
  if (isArray(value)) {
    return some(value, hasNestedScriptExpression);
  }

  if (isObject(value)) {
    return some(value, hasNestedScriptExpression);
  }

  return isScript(value);
};

export const isScript = (value: any): value is string =>
  isString(value) && /^\s*{{([\S\s]+)}}\s*$/g.test(value.trim());

export const validateScript = (value: string) => {
  try {
    // Function(getFuncBody(getScriptBody(value)));
    return;
  } catch (err) {
    return err;
  }
};

export const getScriptBody = (value: string): string => {
  const m = /^\s*{{([\S\s]+)}}\s*$/g.exec(value);

  if (!m) {
    throw new Error(`Not a valid script: ${value}`);
  }

  return m[1].trim();
};

const makeFuncBody = (script: string, ...variables: string[]): string => {
  const vars = variables.map((k) => `${k} = this.${k}`).join(',');
  const s = escape(script);

  const const_definitions = vars.length ? `const ${vars};` : '';

  return `"use strict";
    ${const_definitions}
    try {
      return (${script})
    }
    catch (err) {
      console.error('Error expression:', decodeURIComponent("${s}"));
      console.error('Error scope:', this);
      throw(err);
    }`;
};

function Func(script: string, ...variables: string[]) {
  try {
    // log('make func: %s', script);
    // log('variables: %o', variables);
    const body = makeFuncBody(script, ...variables);
    log('body: %s', body);
    return Function(body);
  } catch (err) {
    console.error(script);
    throw err;
  }
}

const makeComplexFunctionBody = (
  script: string,
  ...variables: string[]
): string => {
  const vars = variables.map((k) => `${k} = this.${k}`).join(',');
  const s = escape(script);

  const const_definitions = vars.length ? `const ${vars};` : '';

  return `"use strict";
    ${const_definitions}
    try {
      ${script}
    }
    catch (err) {
      console.error('Error expression:', decodeURIComponent("${s}"));
      console.error('Error scope:', this);
      throw(err);
    }`;
};

function ComplexFunc(script: string, ...variables: string[]) {
  try {
    const body = makeComplexFunctionBody(script, ...variables);
    return Function(body);
  } catch (err) {
    console.error(script);
    throw err;
  }
}

export function makeFunc(
  script: string,
  scopeVars?: Dictionary<any>,
): Function {
  if (!isScript(script)) {
    throw new TypeError(`Not a valid Function definition: ${script}`);
  }

  const fn = Func(getScriptBody(script), 'it', ...keys(scopeVars));

  return function (scope: Dictionary<any>) {
    try {
      return fn.call({ ...scopeVars, it: scope });
    } catch (err) {
      console.error(err);
      throw err;
    }
  };
}

function makeComplexFunction(
  script: string,
  scopeVars?: Dictionary<any>,
): Function {
  const body = isScript(script) ? getScriptBody(script) : script;
  const fn = ComplexFunc(body, 'it', ...keys(scopeVars));

  return function (scope: Dictionary<any>) {
    try {
      return fn.call({ ...scopeVars, it: scope });
    } catch (err) {
      console.error(err);
      throw err;
    }
  };
}

function getComputedValues(component: ComponentContext, ...skip: string[]) {
  const result: Dictionary<any> = {};
  // if (component.spec.computed) {
  //   for (const key of Object.keys(component.spec.computed)) {
  //     // console.log('...', skip);
  //     if (skip && skip.indexOf(key) > -1) {
  //       // console.log('skipping', key);
  //       result[key] = undefined;
  //       continue;
  //     }
  //     // console.log('retrieving', key);
  //     result[key] = get(component, key);
  //   }
  // }
  return result;
}
